/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Checkbox, FormControlLabel, Typography, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { urlsAndEmail } from 'const';

import Styles from './styles';

const useStyles = makeStyles(Styles);
const mailtoLink = `mailto:${urlsAndEmail.supportEmail}`;

function BookingTermsAndPolicy({ onTermsAccepted }) {
  const styles = useStyles();
  const [consent, setConsent] = useState({ terms: false, policy: false });
  const { t } = useTranslation('labels');

  async function updateStatus(statusFor, status) {
    setConsent((prevState) => ({ ...prevState, [statusFor]: status }));
  }

  useEffect(async () => {
    if (consent.terms && consent.policy) {
      onTermsAccepted(true);
    } else {
      onTermsAccepted(false);
    }
  }, [consent]);

  return (
    <Box sx={{ width: '100%' }} className={styles.termsContainer}>
      <Typography variant="h1" component="h1" className={styles.h1Title}>
        {t('terms_and_conditions_consent')}
      </Typography>
      <Typography variant="p" component="p">
        {t('terms_and_conditions_submit')}
      </Typography>
      <Box sx={{ width: '100%' }} className={styles.marginTop20}>
        <Typography variant="p" component="p">
          {t('terms_and_conditions_read_terms')}
          <a href={urlsAndEmail.termsUrl} rel="noreferrer" target="_blank">
            {urlsAndEmail.termsUrl}
          </a>
        </Typography>
        <Typography variant="p" component="p">
          {t('terms_and_conditions_read_privacy_policy')}
          <a href={urlsAndEmail.privacyUrl} rel="noreferrer" target="_blank">
            {urlsAndEmail.privacyUrl}
          </a>
        </Typography>
      </Box>
      <Box sx={{ width: '100%' }} className={styles.marginTop20}>
        <Typography variant="p" component="p">
          {t('terms_and_conditions_personal_information')}
        </Typography>
        <Typography variant="p" component="p">
          {t('terms_and_conditions_personal_information_1')}
        </Typography>
        <Typography variant="p" component="p">
          {t('terms_and_conditions_personal_information_2')}
        </Typography>
        <Typography variant="p" component="p">
          {t('terms_and_conditions_personal_information_3')}
        </Typography>
        <Typography variant="p" component="p">
          {t('terms_and_conditions_personal_information_4')}
        </Typography>
        <Typography variant="p" component="p">
          {t('terms_and_conditions_personal_information_5')}
        </Typography>
        <FormControlLabel
          className={styles.checkboxLabel}
          control={
            <Checkbox
              data-testid="checkbox_terms"
              name="terms"
              color="primary"
              role="checkbox"
              checked={consent.terms}
              onChange={() => {
                updateStatus('terms', !consent.terms);
              }}
            />
          }
          label={t('terms_and_conditions_accept_terms')}
        />
        <FormControlLabel
          className={styles.checkboxLabel}
          control={
            <Checkbox
              data-testid="checkbox_policy"
              name="policy"
              color="primary"
              role="checkbox"
              checked={consent.policy}
              onChange={() => {
                updateStatus('policy', !consent.policy);
              }}
            />
          }
          label={t('terms_and_conditions_accept_privacy_policy')}
        />
      </Box>
    </Box>
  );
}

BookingTermsAndPolicy.propTypes = {
  onTermsAccepted: PropTypes.any.isRequired,
};

export default BookingTermsAndPolicy;
